import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../lib/auth-context.js'
import { loadEphemeralSession } from '../lib/ephemeral-session.js'

/**
 * 認証必須ルートのガード。
 *
 * - Supabase セッションがあれば通す
 * - 暫定テナントセッションがあれば通す（フック領域として）
 * - どちらも無ければ /login へリダイレクト（公開トップは別ルート）
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { session, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-sm text-muted-foreground">読み込み中...</p>
      </div>
    )
  }

  if (!session && !loadEphemeralSession()) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return <>{children}</>
}
